import React, { useState } from 'react';
import { TextField, Button, Paper, Typography, CircularProgress } from '@mui/material';
import { videoService, VideoMetadata } from '../services/api';

interface UrlInputProps {
  onVideoInfo: (info: VideoMetadata) => void;
  setError: (error: string | null) => void;
}

const UrlInput: React.FC<UrlInputProps> = ({ onVideoInfo, setError }) => {
  const [url, setUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  };

  const handleSearch = async () => {
    if (!url) {
      setError('Please enter an X post URL');
      return;
    }

    // Simple URL validation for X/Twitter only
    const urlPattern = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.+/;
    if (!urlPattern.test(url)) {
      setError('Please enter a valid X post URL');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const videoInfo = await videoService.getVideoInfo(url);
      onVideoInfo(videoInfo);
      setUrl(''); // Clear the input field after successful fetch
    } catch (error) {
      setError(error instanceof Error ? error.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Paper elevation={3} className="p-4 mb-4">
      <div className="flex items-center mb-2">
        <Typography variant="h6">
          Enter X Post URL
        </Typography>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Paste X URL here..."
          value={url}
          onChange={handleUrlChange}
          onKeyDown={handleKeyDown}
          disabled={loading}
          aria-label="X Post URL input"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          disabled={loading}
          className="whitespace-nowrap"
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Get Media'}
        </Button>
      </div>
    </Paper>
  );
};

export default UrlInput; 